<template>
    <div>
        <!-- 顶部标签导航 -->
        <el-tabs v-model="activeTab" type="card" tab-position="top" class="carousel-tabs" @tab-click="handleTabClick">
            <el-tab-pane label="邀请列表" name="manage"></el-tab-pane>
            <el-tab-pane label="邀请设置" name="setting"></el-tab-pane>
        </el-tabs>

        <!-- 设置页面 -->
        <div v-if="activeTab === 'setting'">
            <div class="carousel-banner">
                <div class="carousel-banner-title">邀请设置</div>
            </div>
            <el-card class="carousel-setting-card">
                <el-alert type="success" show-icon style="margin-bottom: 24px; border-radius: 8px;">
                    开启邀请活动后，会为每个群成员生成一个单独的链接，群成员将链接分享给别人，别人点击链接第一次进群，视为成功邀请。
                </el-alert>

                <el-form label-width="120px" style="max-width: 500px; margin: 0 auto;">


                    <el-form-item label="是否启用：">
                        <el-switch v-model="inviteconfig.isEnable" class="big-switch" />
                    </el-form-item>

                    <el-form-item label="我的链接关键词">
                        <el-input v-model="inviteconfig.myLinkKeyword" placeholder="请输入我的链接关键词" />
                    </el-form-item>



                    <el-form-item prop="replaytext" label="我的链接回复内容" label-width="120px">
                        <div :key="editorMyLinkKey" class="html-editor">
                            <!-- 简单的 HTML 工具栏 -->
                            <div class="html-toolbar">
                                <button @click="insertHtmlMyLink('<b>', '</b>')" type="button" title="加粗">
                                    <strong>B</strong>
                                </button>
                                <button @click="insertHtmlMyLink('<i>', '</i>')" type="button" title="斜体">
                                    <em>I</em>
                                </button>
                                <button @click="insertHtmlMyLink('<u>', '</u>')" type="button" title="下划线">
                                    <u>U</u>
                                </button>
                                <button @click="insertHtmlMyLink('<br>')" type="button" title="换行">
                                    换行
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlMyLink('<h1>', '</h1>')" type="button" title="标题1">
                                    H1
                                </button>
                                <button @click="insertHtmlMyLink('<h2>', '</h2>')" type="button" title="标题2">
                                    H2
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlMyLink('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                    • 列表
                                </button>
                                <button @click="insertHtmlMyLink('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                    1. 列表
                                </button>
                                <span class="divider">|</span>
                                <button @click="toggleModeMyLink" type="button"
                                    :title="isSourceModeMyLink ? '切换到可视化模式' : '切换到源码模式'"
                                    :class="{ 'is-active': isSourceModeMyLink }">
                                    {{ isSourceModeMyLink ? '可视' : '源码' }}
                                </button>
                            </div>
                            <!-- 编辑器内容区域 -->
                            <div class="editor-content-area">
                                <!-- 可视化编辑模式 -->
                                <div v-if="!isSourceModeMyLink" ref="visualEditorMyLink" class="visual-editor"
                                    contenteditable="true" @input="handleVisualInputMyLink"
                                    @compositionstart="handleCompositionStartMyLink"
                                    @compositionend="handleCompositionEndMyLink" @paste="handlePasteMyLink"
                                    @keydown="handleKeydownMyLink">
                                </div>
                                <!-- 源码编辑模式 -->
                                <el-input v-if="isSourceModeMyLink" ref="htmlTextareaMyLink"
                                    v-model="inviteconfig.myLinkHtml" type="textarea" :rows="8"
                                    placeholder="请输入内容，支持HTML标签..." class="html-textarea" />
                            </div>
                        </div>
                    </el-form-item>


                    <div class="variable-help-text">
                        <span class="variable-item"><code>{member}</code>群成员名字，</span>
                        <span class="variable-item"><code>{inviteLink}</code>邀请链接，</span>
                        <span class="variable-item"><code>{inviteNum}</code>为已邀请人数，</span>
                        <span class="variable-item"><code>{inviteRankList}</code>为邀请排名，</span>
                    </div>




                    <el-form-item prop="replaytext" label="邀请成功提示内容" label-width="120px">
                        <div :key="editorSuccessKey" class="html-editor">
                            <!-- 简单的 HTML 工具栏 -->
                            <div class="html-toolbar">
                                <button @click="insertHtmlSuccess('<b>', '</b>')" type="button" title="加粗">
                                    <strong>B</strong>
                                </button>
                                <button @click="insertHtmlSuccess('<i>', '</i>')" type="button" title="斜体">
                                    <em>I</em>
                                </button>
                                <button @click="insertHtmlSuccess('<u>', '</u>')" type="button" title="下划线">
                                    <u>U</u>
                                </button>
                                <button @click="insertHtmlSuccess('<br>')" type="button" title="换行">
                                    换行
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlSuccess('<h1>', '</h1>')" type="button" title="标题1">
                                    H1
                                </button>
                                <button @click="insertHtmlSuccess('<h2>', '</h2>')" type="button" title="标题2">
                                    H2
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlSuccess('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                    • 列表
                                </button>
                                <button @click="insertHtmlSuccess('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                    1. 列表
                                </button>
                                <span class="divider">|</span>
                                <button @click="toggleModeSuccess" type="button"
                                    :title="isSourceModeSuccess ? '切换到可视化模式' : '切换到源码模式'"
                                    :class="{ 'is-active': isSourceModeSuccess }">
                                    {{ isSourceModeSuccess ? '可视' : '源码' }}
                                </button>
                            </div>
                            <!-- 编辑器内容区域 -->
                            <div class="editor-content-area">
                                <!-- 可视化编辑模式 -->
                                <div v-if="!isSourceModeSuccess" ref="visualEditorSuccess" class="visual-editor"
                                    contenteditable="true" @input="handleVisualInputSuccess"
                                    @compositionstart="handleCompositionStartSuccess"
                                    @compositionend="handleCompositionEndSuccess" @paste="handlePasteSuccess"
                                    @keydown="handleKeydownSuccess">
                                </div>
                                <!-- 源码编辑模式 -->
                                <el-input v-if="isSourceModeSuccess" ref="htmlTextareaSuccess"
                                    v-model="inviteconfig.successHtml" type="textarea" :rows="8"
                                    placeholder="请输入内容，支持HTML标签..." class="html-textarea" />
                            </div>
                        </div>
                    </el-form-item>


                    <div class="variable-help-text">
                        <span class="variable-item"><code>{member}</code>群成员名字，</span>
                        <span class="variable-item"><code>{inviteMember}</code>为被邀请成员，</span>
                        <span class="variable-item"><code>{inviteNum}</code>为已邀请人数</span>
                        <!-- <span class="variable-item"><code>{inviteRankList}</code>为邀请排名</span> -->
                    </div>



                    <!-- 附加按钮 -->
                    <el-form-item prop="buttons" label="附加按钮" label-width="80px">
                        <!-- 按钮行列表 -->
                        <div v-if="inviteconfig.successBtnList.length > 0" class="button-rows-list">
                            <div v-for="(row, rowIndex) in inviteconfig.successBtnList"
                                :key="`row-${rowIndex}-${JSON.stringify(row)}`" class="button-row-wrapper"
                                @dragover="handleDragOver" @drop="handleDrop($event, rowIndex, 'success')"
                                :class="{ 'drag-over': draggedRowIndex !== null && draggedRowIndex !== rowIndex }">
                                <!-- 灰色按钮容器 -->
                                <div class="gray-buttons-container">
                                    <div v-for="(button, btnIndex) in row" :key="btnIndex" class="button-item">
                                        {{ button.text || '按钮' }}
                                        <div class="button-actions">
                                            <div class="button-action-icon edit-icon"
                                                @click="editButton(rowIndex, btnIndex, 'success')" title="编辑按钮">
                                                <el-icon>
                                                    <Edit />
                                                </el-icon>
                                            </div>
                                            <div class="button-action-icon delete-icon"
                                                @click="removeButton(rowIndex, btnIndex, 'success')" title="删除按钮">
                                                <el-icon>
                                                    <Delete />
                                                </el-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 只有当行数 >= 1 时，才显示"本行新增一个按钮" -->
                                <div v-if="inviteconfig.successBtnList.length >= 1" class="add-button-container">
                                    <button @click="showAddButtonDialog(rowIndex, 'success')" type="button"
                                        class="add-to-row-button">
                                        + 本行新增一个按钮
                                    </button>
                                </div>
                                <!-- 右侧拖拽图标 -->
                                <div class="drag-icon-container" :title="'拖拽移动第' + (rowIndex + 1) + '行'"
                                    draggable="true" @dragstart="handleDragStart(rowIndex)" @dragend="handleDragEnd">
                                    <el-icon class="drag-icon">
                                        <Rank />
                                    </el-icon>
                                </div>
                            </div>
                        </div>

                        <!-- 新增一行按钮 -->
                        <div class="button-controls">
                            <button @click="showAddButtonDialog(-1, 'success')" type="button" class="add-row-button">
                                + 新增一行按钮
                            </button>
                        </div>
                    </el-form-item>

                    <!-- 添加按钮对话框 -->
                    <el-dialog v-model="buttonDialogVisible" :title="getDialogTitle()" width="600px"
                        :close-on-click-modal="false" destroy-on-close>
                        <el-form :model="buttonForm" :rules="buttonRules" ref="buttonFormRef" label-width="80px">
                            <el-form-item label="按钮文字" prop="text">
                                <el-input v-model="buttonForm.text" placeholder="请输入按钮文字" />
                            </el-form-item>
                            <el-form-item label="链接" prop="url">
                                <el-input v-model="buttonForm.url" placeholder="请输入http(s)://开头的链接或者留空（留空表示内置链接）" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="buttonDialogVisible = false">取消</el-button>
                                <el-button type="primary" @click="confirmAddButton">确定</el-button>
                            </div>
                        </template>
                    </el-dialog>






                    <!-- <el-form-item prop="replaytext" label="邀请提示内容" label-width="120px">
                        <div :key="editorPublicKey" class="html-editor">
                            
                            <div class="html-toolbar">
                                <button @click="insertHtmlPublic('<b>', '</b>')" type="button" title="加粗">
                                    <strong>B</strong>
                                </button>
                                <button @click="insertHtmlPublic('<i>', '</i>')" type="button" title="斜体">
                                    <em>I</em>
                                </button>
                                <button @click="insertHtmlPublic('<u>', '</u>')" type="button" title="下划线">
                                    <u>U</u>
                                </button>
                                <button @click="insertHtmlPublic('<br>')" type="button" title="换行">
                                    换行
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlPublic('<h1>', '</h1>')" type="button" title="标题1">
                                    H1
                                </button>
                                <button @click="insertHtmlPublic('<h2>', '</h2>')" type="button" title="标题2">
                                    H2
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlPublic('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                    • 列表
                                </button>
                                <button @click="insertHtmlPublic('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                    1. 列表
                                </button>
                                <span class="divider">|</span>
                                <button @click="toggleModePublic" type="button"
                                    :title="isSourceModePublic ? '切换到可视化模式' : '切换到源码模式'"
                                    :class="{ 'is-active': isSourceModePublic }">
                                    {{ isSourceModePublic ? '可视' : '源码' }}
                                </button>
                            </div>
                            
                            <div class="editor-content-area">
                                
                                <div v-if="!isSourceModePublic" ref="visualEditorPublic" class="visual-editor"
                                    contenteditable="true" @input="handleVisualInputPublic"
                                    @compositionstart="handleCompositionStartPublic"
                                    @compositionend="handleCompositionEndPublic" @paste="handlePastePublic"
                                    @keydown="handleKeydownPublic">
                                </div>
                                
                                <el-input v-if="isSourceModePublic" ref="htmlTextareaPublic"
                                    v-model="inviteconfig.publicHtml" type="textarea" :rows="8"
                                    placeholder="请输入内容，支持HTML标签..." class="html-textarea" />
                            </div>
                        </div>
                    </el-form-item> -->



                    <!-- <div class="variable-help-text">
                        <span class="variable-item"><code>{member}</code>为邀请人，</span>
                        <span class="variable-item"><code>{groupInfo}</code>为群信息</span>
                    </div> -->



                    <!-- <el-form-item prop="buttons" label="附加按钮" label-width="80px">
                        
                        <div v-if="inviteconfig.publicBtnList.length > 0" class="button-rows-list">
                            <div v-for="(row, rowIndex) in inviteconfig.publicBtnList"
                                :key="`row-${rowIndex}-${JSON.stringify(row)}`" class="button-row-wrapper"
                                @dragover="handleDragOver" @drop="handleDrop($event, rowIndex, 'public')"
                                :class="{ 'drag-over': draggedRowIndex !== null && draggedRowIndex !== rowIndex }">
                                
                                <div class="gray-buttons-container">
                                    <div v-for="(button, btnIndex) in row" :key="btnIndex" class="button-item">
                                        {{ button.text || '按钮' }}
                                        <div class="button-actions">
                                            <div class="button-action-icon edit-icon"
                                                @click="editButton(rowIndex, btnIndex, 'public')" title="编辑按钮">
                                                <el-icon>
                                                    <Edit />
                                                </el-icon>
                                            </div>
                                            <div class="button-action-icon delete-icon"
                                                @click="removeButton(rowIndex, btnIndex, 'public')" title="删除按钮">
                                                <el-icon>
                                                    <Delete />
                                                </el-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div v-if="inviteconfig.publicBtnList.length >= 1" class="add-button-container">
                                    <button @click="showAddButtonDialog(rowIndex, 'public')" type="button"
                                        class="add-to-row-button">
                                        + 本行新增一个按钮
                                    </button>
                                </div>
                                
                                <div class="drag-icon-container" :title="'拖拽移动第' + (rowIndex + 1) + '行'"
                                    draggable="true" @dragstart="handleDragStart(rowIndex)" @dragend="handleDragEnd">
                                    <el-icon class="drag-icon">
                                        <Rank />
                                    </el-icon>
                                </div>
                            </div>
                        </div>


                        <div class="button-controls">
                            <button @click="showAddButtonDialog(-1, 'public')" type="button" class="add-row-button">
                                + 新增一行按钮
                            </button>
                        </div>
                    </el-form-item> -->


                    <!-- <el-dialog v-model="buttonDialogVisible" :title="getDialogTitle()" width="600px"
                        :close-on-click-modal="false" destroy-on-close>
                        <el-form :model="buttonForm" :rules="buttonRules" ref="buttonFormRef" label-width="80px">
                            <el-form-item label="按钮文字" prop="text">
                                <el-input v-model="buttonForm.text" placeholder="请输入按钮文字" />
                            </el-form-item>
                            <el-form-item label="链接" prop="url">
                                <el-input v-model="buttonForm.url" placeholder="请输入http(s)://开头的链接或者留空（留空表示内置链接）" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="buttonDialogVisible = false">取消</el-button>
                                <el-button type="primary" @click="confirmAddButton">确定</el-button>
                            </div>
                        </template>
                    </el-dialog> -->










                    <el-form-item label="人工审核">
                        <el-switch v-model="inviteconfig.isApprove" class="big-switch" />
                    </el-form-item>

                    <el-form-item label="邀请一个人积分">
                        <el-input v-model="inviteconfig.inviteAwardNum" placeholder="请输入邀请一个人积分" />
                    </el-form-item>


                    <el-form-item label="每日最大积分">
                        <el-input v-model="inviteconfig.dayMaxPoint" placeholder="请输入每日最大积分" />
                    </el-form-item>










                    <el-form-item>
                        <el-button type="primary" class="big-submit-btn" @click="saveSetting">提交</el-button>
                    </el-form-item>


                </el-form>
            </el-card>
        </div>

        <!-- 列表页面 -->
        <div v-else>
            <!-- 原有内容保持不变 -->
            <div class="auto-reply">
                <div class="search-section">
                    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                        <el-form-item label="搜索用户">
                            <el-input v-model="searchForm.keyword" placeholder="请输入用户id/昵称/用户名" clearable size="large"
                                style="width: 200px">
                            </el-input>
                        </el-form-item>


                        <el-form-item label="邀请状态">
                            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable size="large"
                                style="width: 120px">
                                <el-option label="启用" :value="1" />
                                <el-option label="禁用" :value="0" />
                            </el-select>
                        </el-form-item>



                        <el-form-item>
                            <div class="button-group">
                                <el-button type="primary" @click="onSearch" size="large">
                                    <el-icon>
                                        <Search />
                                    </el-icon>
                                    搜索
                                </el-button>
                                <el-button @click="resetSearch" size="large">
                                    <el-icon>
                                        <Refresh />
                                    </el-icon>
                                    重置
                                </el-button>

                                <el-button type="warning" @click="handleImport" size="large">
                                    <el-icon>
                                        <Upload />
                                    </el-icon>
                                    导入
                                </el-button>
                                <el-button type="info" @click="handleExport" size="large">
                                    <el-icon>
                                        <Download />
                                    </el-icon>
                                    导出
                                </el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>



                <el-divider></el-divider>

                <!-- 数据表格 -->
                <el-table :data="tableData" style="width: 100%" v-loading="loading">


                    <el-table-column prop="nickname" label="用户/id" min-width="500">
                        <template #default="scope">
                            {{ scope.row.nickname }} [{{ scope.row.userId }}]
                        </template>
                    </el-table-column>


                    <el-table-column prop="userName" label="用户名" min-width="150">
                        <template #default="scope">
                            {{ scope.row.userName }}
                        </template>
                    </el-table-column>


                    <el-table-column prop="inviteLink" label="邀请链接" min-width="300">
                        <template #default="scope">
                            {{ scope.row.inviteLink }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="inviteName" label="链接名称" min-width="100">
                        <template #default="scope">
                            {{ scope.row.inviteName }}
                        </template>
                    </el-table-column>



                    <el-table-column prop="inviteNum" label="已邀请人数" min-width="100">
                        <template #default="scope">
                            {{ scope.row.inviteNum }}（人）
                        </template>
                    </el-table-column>





                    <el-table-column prop="status" label="状态" width="100">
                        <template #default="scope">
                            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                                @change="handleStatusChange(scope.row)">
                            </el-switch>
                        </template>
                    </el-table-column>


                    <el-table-column label="操作" width="280" fixed="right">
                        <template #default="scope">
                            <el-button type="primary" size="small" @click="handleDetail(scope.row)">
                                <el-icon>
                                    <ViewIcon />
                                </el-icon>
                                详情
                            </el-button>
                            <el-button type="danger" size="small" @click="handleDelete(scope.row)">
                                <el-icon>
                                    <Delete />
                                </el-icon>
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页组件 -->
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>



                <!-- 导入对话框 -->
                <el-dialog v-model="importVisible" title="导入轮播广告（JSON格式）" width="600px">
                    <el-input type="textarea" v-model="jsonInput" :rows="8"
                        placeholder="可粘贴 JSON 或拖拽上传 .json 文件，将自动提取数组数据" style="margin-bottom: 16px;" />
                    <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: center;">
                        <el-button size="small" @click="toggleJsonFormat" :disabled="!jsonInput">
                            <el-icon>
                                <ViewIcon />
                            </el-icon>
                            {{ isFormatted ? '压缩显示' : '格式化显示' }}
                        </el-button>
                        <span v-if="previewCount > 0" style="color: #67c23a; font-size: 14px;">
                            已识别到 {{ previewCount }} 条数据
                        </span>
                    </div>
                    <el-upload :show-file-list="false" accept=".json,application/json" :before-upload="handleJsonFile"
                        drag class="json-upload-drag">
                        <el-icon class="el-icon--upload">
                            <Upload />
                        </el-icon>
                        <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                        </div>
                        <template #tip>
                            <div class="el-upload__tip">
                                支持粘贴或上传 JSON 文件，格式如：{ code, data: { records: [...] } }<br>
                                将自动提取数组数据并压缩显示，字段需与导出格式一致。
                            </div>
                        </template>
                    </el-upload>
                    <template #footer>
                        <div class="dialog-footer">
                            <el-button @click="importVisible = false">取消</el-button>
                            <el-button type="primary" @click="confirmImport" :loading="importLoading"
                                :disabled="!jsonInput">
                                {{ importLoading ? '正在导入...' : '确定导入' }}
                            </el-button>
                        </div>
                    </template>
                </el-dialog>

                <!-- 邀请详情弹窗 -->
                <el-dialog v-model="detailDialogVisible" title="邀请详情" width="1200px" :close-on-click-modal="false">
                    <div v-loading="inviteUsersLoading">
                        <el-table :data="inviteUsersData" style="width: 100%">
                            <el-table-column prop="inviteNickname" label="邀请人" min-width="200">
                                <template #default="scope">
                                    {{ scope.row.inviteNickname }} [{{ scope.row.inviteUserId }}]
                                </template>
                            </el-table-column>
                            <el-table-column prop="inviteUserName" label="邀请人用户名" min-width="150">
                                <template #default="scope">
                                    {{ scope.row.inviteUserName }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="userId" label="被邀请人id" min-width="120">
                                <template #default="scope">
                                    {{ scope.row.userId }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="userName" label="被邀请人用户名" min-width="150">
                                <template #default="scope">
                                    {{ scope.row.userName }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="nickname" label="被邀请人昵称" min-width="200">
                                <template #default="scope">
                                    {{ scope.row.nickname }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="isInvalid" label="无效邀请" min-width="100">
                                <template #default="scope">
                                    <el-tag :type="scope.row.isInvalid === 1 ? 'danger' : 'success'" size="small">
                                        {{ scope.row.isInvalid === 1 ? '是' : '否' }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="inviteTime" label="邀请时间" min-width="150">
                                <template #default="scope">
                                    {{ formatDateTime(scope.row.inviteTime) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120" fixed="right">
                                <template #default="scope">
                                    <el-button type="primary" size="small" @click="handleSetInvalid(scope.row)">
                                        {{ scope.row.isInvalid === 1 ? '已无效' : '设为无效' }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 分页组件 -->
                        <div class="pagination" style="margin-top: 20px;">
                            <el-pagination @size-change="handleInviteUsersSizeChange"
                                @current-change="handleInviteUsersCurrentChange" :current-page="inviteUsersCurrentPage"
                                :page-sizes="[10, 20, 50, 100]" :page-size="inviteUsersPageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="inviteUsersTotal">
                            </el-pagination>
                        </div>
                    </div>
                </el-dialog>


            </div>
        </div>
    </div>
</template>

<script>
import { Search, Refresh, Edit, Delete, Upload, Download, Rank, View as ViewIcon } from '@element-plus/icons-vue'
import api from '@/services/api'

export default {
    name: 'AutoReply',
    components: {
        Search,
        Refresh,
        Edit,
        Delete,
        Upload,
        Download,
        Rank,
        ViewIcon
    },
    data() {
        return {
            searchForm: {
                keyword: '',
                status: ''
            },
            inviteconfig: {
                isEnable: false,
                myLinkKeyword: '邀请',
                isApprove: false,
                inviteAwardNum: 100,
                dayMaxPoint: 1000,
                myLinkHtml: '{member}，您的专属链接是：{inviteLink}(点击复制)<br>👉 您已邀请{ inviteNum } 人<br><br>邀请排行榜：<br>{ inviteRankList } ',
                successHtml: '{member}，恭喜您成功邀请{inviteMember}。<br>👉 您已邀请{inviteNum}人<br>',
                publicHtml: '{member}邀请您加入群{groupInfo}<br>',
                successBtnList: [],
                publicBtnList: []
            },
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            statsVisible: false,
            stats: {
                overview: null
            },
            dialogType: 'create',
            importVisible: false,
            importLoading: false,
            selectedFile: null,
            currentUserInfo: {
                userid: null,
                groupid: null,
                userBot: null
            },
            form: {
                userBot: null,
                groupid: null,
                userid: null,
                buttons: []
            },
            rules: {
                msgContent: [
                    {
                        required: true,
                        message: '请输入轮播文本内容',
                        trigger: 'blur',
                        validator: (rule, value, callback) => {

                            if (!value || value.trim() === '') {
                                callback(new Error('请输入轮播文本内容'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                endTime: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && this.form.startTime && value <= this.form.startTime) {
                                callback(new Error('结束时间必须晚于开始时间'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ]
            },
            // 富文本编辑器相关数据
            isSourceMode: false,
            isComposing: false,
            updateTimer: null,
            // 三个富文本编辑器的独立状态
            isSourceModeMyLink: false,
            isSourceModeSuccess: false,
            isSourceModePublic: false,
            editorMyLinkKey: 'myLink',
            editorSuccessKey: 'success',
            editorPublicKey: 'public',
            // 按钮相关数据
            buttonForm: {
                text: '',
                url: ''
            },
            buttonDialogVisible: false,
            editingButtonRowIndex: -1,
            editingButtonIndex: -1,
            currentRowIndex: -1,
            draggedRowIndex: null,

            buttonRules: {
                text: [
                    { required: true, message: '请输入按钮文字', trigger: 'blur' }
                ],
                url: [
                    {
                        validator(rule, value, callback) {
                            if (!value) {
                                callback(); // 允许为空
                            } else if (/^https?:\/\/.+/.test(value)) {
                                callback(); // 合法链接
                            } else {
                                callback(new Error('链接地址必须为空或以 http:// 或 https:// 开头'));
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            activeTab: 'manage',
            setting: {
                enabled: true,
                interval: 5,
                mode: 'send_and_pin',
                cancelLastPin: false,
                deleteLastAd: false
            },
            jsonInput: '',
            previewCount: 0,
            isFormatted: false,
            // 邀请详情弹窗相关数据
            detailDialogVisible: false,
            inviteUsersData: [],
            inviteUsersLoading: false,
            inviteUsersCurrentPage: 1,
            inviteUsersPageSize: 10,
            inviteUsersTotal: 0,
            currentInviteUserId: null,
            currentInviteGroupId: null,
            currentBtnListType: 'success' // 当前操作的按钮列表类型：'success' 或 'public'
        }
    },
    computed: {
        vuexUser() {
            return this.$store.state.user;
        }
    },
    watch: {
        vuexUser: {
            handler(newUser) {
                if (newUser) {
                    this.loadUserInfo(newUser);
                }
            },
            deep: true,
            immediate: true
        },
        jsonInput: {
            handler(newValue) {
                if (newValue && newValue.trim()) {
                    this.processJsonInput(newValue);
                } else {
                    this.previewCount = 0;
                }
            },
            immediate: false
        }
    },
    methods: {

        handleTabClick(tab) {
            // console.log('标签点击:', JSON.stringify(tab));
            if (tab.paneName == 'manage') {
                this.fetchData()
            } else if (tab.paneName == 'setting') {
                this.initRichTextEditor();
                this.fetchSetting()
            }
        },

        fetchSetting() {
            /////////调用group表的对应api接口获取群的配置
            api.getGroupById(this.currentUserInfo.groupId).then(res => {
                if (res.data.inviteconfig && res.data.inviteconfig != null && res.data.inviteconfig != '') {
                    this.inviteconfig = res.data.inviteconfig;
                }
            }).catch(error => {
                this.$message.error('获取配置失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            });
        },


        saveSetting() {
            api.updateInviteConfig(this.currentUserInfo.groupId, {
                inviteconfig: this.inviteconfig
            }).then(res => {
                if (res.data.code == 0) {
                    this.$message.success('邀请配置保存成功');
                    this.fetchSetting();
                } else {
                    this.$message.error(res.data.message || '保存失败');
                }
            }).catch(error => {
                this.$message.error('保存失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            });
        },



        loadUserInfo(user) {
            this.currentUserInfo.userId = user.userId;
            this.currentUserInfo.groupId = user.groupId;
            this.currentUserInfo.userBot = user.userBot;
        },
        onSearch() {
            this.currentPage = 1
            this.fetchData()
        },
        resetSearch() {
            this.searchForm = {
                keyword: '',
                status: ''
            }
            this.currentPage = 1
            this.fetchData()
        },
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                }

                if (this.searchForm.keyword) {
                    params.keyword = this.searchForm.keyword
                }

                if (this.searchForm.status !== '') {
                    params.status = this.searchForm.status
                }

                const response = await api.getInviteLinksList(params)

                if (response.data.code === 0) {
                    this.tableData = response.data.data.records
                    this.total = response.data.data.total
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('获取邀请链接失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        async fetchStats() {
            try {
                this.loading = true
                const response = await api.getAutoReplyStats()

                if (response.data.code === 0) {
                    this.stats = response.data.data
                    this.statsVisible = true
                } else {
                    this.$message.error(response.data.message || '获取统计信息失败')
                }
            } catch (error) {
                console.error('获取统计信息失败:', error)
                this.$message.error('获取统计信息失败')
            } finally {
                this.loading = false
            }
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        },

        async handleDelete(row) {
            try {
                await this.$confirm('确定要删除这个邀请链接吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })

                const response = await api.deleteInviteLink(row.id)
                if (response.data.code === 0) {
                    this.$message.success('删除成功')
                    this.fetchData()
                } else {
                    this.$message.error(response.data.message || '删除失败')
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除失败:', error)
                    this.$message.error('删除失败')
                }
            }
        },



        async handleDetail(row) {
            try {
                this.currentInviteUserId = row.userId;
                this.currentInviteGroupId = row.groupid;
                this.detailDialogVisible = true;
                this.inviteUsersCurrentPage = 1;
                await this.fetchInviteUsers();
            } catch (error) {
                console.error('获取邀请详情失败:', error);
                this.$message.error('获取邀请详情失败');
            }
        },





        async handleStatusChange(row) {
            try {
                const response = await api.updateInviteLink(row.id, {
                    status: row.status,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                })
                if (response.data.code === 0) {
                    this.$message.success('状态更新成功')
                } else {
                    this.$message.error(response.data.message || '状态更新失败')
                    // 恢复原状态
                    row.status = row.status === 1 ? 0 : 1
                }
            } catch (error) {
                console.error('状态更新失败:', error)
                this.$message.error('状态更新失败')
                // 恢复原状态
                row.status = row.status === 1 ? 0 : 1
            }
        },
        async handleSubmit() {
            try {
                await this.$refs.formRef.validate();
                const finalForm = { ...this.form };

                if (!finalForm.inviteName || finalForm.inviteName.trim() === '') {
                    this.$message.error('请输入邀请名称');
                    return;
                }
                finalForm.status = parseInt(finalForm.status) || 1;

                if (!finalForm.remark) {
                    finalForm.remark = '';
                }
                let response;
                if (this.dialogType === 'create') {
                    finalForm.userId = this.currentUserInfo.userId;
                    finalForm.groupid = this.currentUserInfo.groupId;
                    finalForm.userBot = this.currentUserInfo.userBot;
                    finalForm.createTime = new Date();
                    if (!finalForm.userId || !finalForm.groupid || !finalForm.userBot) {
                        this.$message.error('用户信息不完整，请刷新页面后重试');
                        return;
                    }
                    response = await api.createInviteLink(finalForm);
                } else {
                    finalForm.groupid = this.currentUserInfo.groupId;
                    finalForm.userBot = this.currentUserInfo.userBot;
                    if (!finalForm.id) {
                        this.$message.error('邀请链接ID丢失，请刷新页面后重试');
                        return;
                    }
                    response = await api.updateInviteLink(finalForm.id, finalForm);
                }
                if (response.data.code === 0) {
                    this.$message.success(this.dialogType === 'create' ? '创建成功' : '更新成功');
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '操作失败');
                }
            } catch (error) {
                console.error('=== handleSubmit 异常 ===');
                console.error('错误类型:', error.name);
                console.error('错误消息:', error.message);
                console.error('错误堆栈:', error.stack);
                if (error.response) {
                    console.error('HTTP响应错误:', JSON.stringify({
                        status: error.response.status,
                        statusText: error.response.statusText,
                        data: error.response.data
                    }, null, 2));
                }
                this.$message.error(error.response?.data?.message || error.message || '操作失败');
            }
        },
        handleImport() {
            this.importVisible = true
            this.jsonInput = ''
            this.previewCount = 0
            this.isFormatted = false
        },
        async handleJsonFile(file) {
            // 读取本地json文件内容并填充到textarea
            const reader = new FileReader();
            reader.onload = (e) => {
                this.jsonInput = e.target.result;
                // 自动处理文件内容
                this.processJsonInput(e.target.result);
            };
            reader.onerror = () => {
                this.$message.error('文件读取失败');
            };
            reader.readAsText(file);
            // 阻止el-upload自动上传
            return false;
        },
        processJsonInput(input) {
            if (!input || !input.trim()) {
                this.previewCount = 0;
                return;
            }
            try {
                const data = JSON.parse(input);
                let records = [];

                // 自动识别格式并提取数组
                if (data && typeof data === 'object' && data.data && Array.isArray(data.data.records)) {
                    records = data.data.records;
                } else if (Array.isArray(data.records)) {
                    records = data.records;
                } else if (Array.isArray(data)) {
                    records = data;
                }

                this.previewCount = records.length;

                if (records.length > 0) {
                    // 压缩显示数组数据
                    this.jsonInput = JSON.stringify(records);
                    this.isFormatted = false;
                    this.$message.success(`成功提取 ${records.length} 条数据`);
                } else {
                    this.$message.warning('未识别到有效的数据记录');
                }
            } catch (e) {
                this.previewCount = 0;
                // 如果不是有效JSON，保持原内容不变
            }
        },
        toggleJsonFormat() {
            if (!this.jsonInput) return;

            try {
                const data = JSON.parse(this.jsonInput);
                if (this.isFormatted) {
                    // 压缩显示
                    this.jsonInput = JSON.stringify(data);
                    this.isFormatted = false;
                } else {
                    // 格式化显示
                    this.jsonInput = JSON.stringify(data, null, 2);
                    this.isFormatted = true;
                }
            } catch (e) {
                this.$message.error('JSON 格式不正确');
            }
        },
        async confirmImport() {
            if (!this.jsonInput) {
                this.$message.warning('请粘贴或上传 JSON 数据');
                return;
            }
            let data;
            try {
                data = JSON.parse(this.jsonInput);
            } catch (e) {
                this.$message.error('JSON 格式不正确');
                return;
            }
            // 现在直接是数组数据
            let importData = data;
            if (!Array.isArray(data)) {
                this.$message.error('数据格式错误，请确保是数组格式');
                return;
            }

            // 添加用户信息
            const importPayload = {
                userBot: this.currentUserInfo.userBot,
                groupid: this.currentUserInfo.groupId,
                userid: this.currentUserInfo.userId,
                records: importData
            };

            this.importLoading = true;
            try {
                var response;
                if (importData[0].inviteUserId) {

                    response = await api.importInviteUsers(importPayload);
                } else {
                    response = await api.importInviteLinks(importPayload);
                }




                if (response.data.code === 0) {
                    this.$message.success(`成功导入 ${response.data.data.importedCount} 条数据`);
                    this.importVisible = false;
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '导入失败');
                }
            } catch (error) {
                this.$message.error('导入失败，请检查数据格式或联系管理员。');
            } finally {
                this.importLoading = false;
            }
        },
        async handleExport() {
            try {
                this.loading = true
                const response = await api.exportInviteLinks({
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                })
                if (response.data.code === 0) {
                    const exportData = response.data.data
                    this.exportToJson(exportData)
                    this.$message.success('导出成功')
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('导出失败:', error)
                this.$message.error('导出失败')
            } finally {
                this.loading = false
            }
        },

        // 导出为JSON文件
        exportToJson(exportData) {
            // 格式化JSON数据
            const jsonContent = JSON.stringify(exportData, null, 2)

            // 创建Blob对象
            const blob = new Blob([jsonContent], { type: 'application/json' })

            // 创建下载链接
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url

            // 生成文件名
            const filename = `邀请链接_${new Date().toISOString().split('T')[0]}.json`
            link.download = filename

            // 触发下载
            document.body.appendChild(link)
            link.click()

            // 清理
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        },
        getloacltime(row) {
            /////////把13位时间戳转换为 格式化时间
            return this.formatDateTime(row)
        },

        formatDateTime(dateTime) {
            if (!dateTime) return '-'
            const date = new Date(dateTime)
            return date.toLocaleString('zh-CN')
        },
        removeButton(rowIndex, btnIndex, btnListType = 'success') {
            const btnList = btnListType === 'public' ? this.inviteconfig.publicBtnList : this.inviteconfig.successBtnList;

            btnList[rowIndex].splice(btnIndex, 1);
            // 如果删除按钮后该行没有按钮了，则删除整行
            if (btnList[rowIndex].length === 0) {
                btnList.splice(rowIndex, 1);

                // 如果当前选中的行被删除了，重置状态
                if (this.currentRowIndex === rowIndex) {
                    this.currentRowIndex = -1;
                }
                // 如果删除的行在当前选中行之前，需要调整索引
                else if (this.currentRowIndex > rowIndex) {
                    this.currentRowIndex--;
                }
            }
        },
        addButton(rowIndex, btnListType = 'success') {
            const btnList = btnListType === 'public' ? this.inviteconfig.publicBtnList : this.inviteconfig.successBtnList;
            btnList[rowIndex].push({ text: '', url: '' });
        },
        editButton(rowIndex, btnIndex, btnListType = 'success') {
            // 设置编辑状态
            this.editingButtonRowIndex = rowIndex;
            this.editingButtonIndex = btnIndex;
            this.currentRowIndex = rowIndex;
            this.currentBtnListType = btnListType;

            // 根据类型选择对应的按钮列表
            const btnList = btnListType === 'public' ? this.inviteconfig.publicBtnList : this.inviteconfig.successBtnList;

            // 填充表单数据
            const button = btnList[rowIndex][btnIndex];
            this.buttonForm.text = button.text;
            this.buttonForm.url = button.url;

            // 显示对话框
            this.buttonDialogVisible = true;
        },


        formatText(type) {
            const textarea = this.$refs.replaytextInput.$refs.textarea;
            if (!textarea) return;

            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const selectedText = this.form.msgContent.msgText.substring(start, end);
            let replacement = selectedText;
            let preSelection = 0;
            let postSelection = 0;

            switch (type) {
                case 'bold':
                    replacement = `**${selectedText}**`;
                    preSelection = 2;
                    postSelection = 2;
                    break;
                case 'italic':
                    replacement = `_${selectedText}_`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'strikethrough':
                    replacement = `~${selectedText}~`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'code':
                    replacement = `\`${selectedText}\``;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'link':
                    {
                        const url = prompt("请输入链接 URL:", "https://");
                        if (url) {
                            replacement = `[${selectedText}](${url})`;
                            preSelection = 1;
                            postSelection = url.length + 3 + (selectedText.length > 0 ? 0 : -selectedText.length);
                        } else {
                            return;
                        }
                        break;
                    }
            }

            this.form.msgContent.msgText = this.form.msgContent.msgText.substring(0, start) + replacement + this.form.msgContent.msgText.substring(end);

            this.$nextTick(() => {
                textarea.focus();
                if (selectedText.length === 0) {
                    const newCursorPos = start + preSelection;
                    textarea.setSelectionRange(newCursorPos, newCursorPos);
                } else {
                    const newStart = start + preSelection;
                    const newEnd = start + replacement.length - postSelection;
                    textarea.setSelectionRange(newStart, newEnd);
                }
            });
        },
        insertHtml(tag, closeTag) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        toggleMode() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleVisualInput(event) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleCompositionStart() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleCompositionEnd(event) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handlePaste() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleKeydown() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        setVisualEditorContent(content) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        // 保存光标位置
        saveCaretPosition() {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                const preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(this.$refs.visualEditor);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                return preCaretRange.toString().length;
            }
            return 0;
        },

        // 恢复光标位置
        restoreCaretPosition(caretPos) {
            const editor = this.$refs.visualEditor;
            if (!editor) return;

            const selection = window.getSelection();
            const range = document.createRange();

            let charIndex = 0;
            let nodeStack = [editor];
            let node, foundStart = false;

            while (!foundStart && (node = nodeStack.pop())) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const nextCharIndex = charIndex + node.textContent.length;
                    if (caretPos >= charIndex && caretPos <= nextCharIndex) {
                        range.setStart(node, caretPos - charIndex);
                        range.setEnd(node, caretPos - charIndex);
                        foundStart = true;
                    }
                    charIndex = nextCharIndex;
                } else {
                    let i = node.childNodes.length;
                    while (i--) {
                        nodeStack.push(node.childNodes[i]);
                    }
                }
            }

            if (foundStart) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },
        handleVisualInputMyLink(event) {
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(() => {
                if (content !== this.inviteconfig.myLinkHtml) {
                    this.inviteconfig.myLinkHtml = content;
                }
            }, 300);
        },
        handleCompositionStartMyLink() {
            this.isComposing = true;
        },
        handleCompositionEndMyLink(event) {
            this.isComposing = false;
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            if (content !== this.inviteconfig.myLinkHtml) {
                this.inviteconfig.myLinkHtml = content;
            }
        },
        handlePasteMyLink() {
            // 让浏览器处理粘贴
        },
        handleKeydownMyLink() {
            // 让浏览器处理按键
        },
        setVisualEditorContentMyLink(content) {
            if (this.$refs.visualEditorMyLink && !this.isSourceModeMyLink) {
                this.$refs.visualEditorMyLink.innerHTML = content || '';
            }
        },

        // 第二个富文本编辑器的方法（邀请成功提示内容）
        insertHtmlSuccess(tag, closeTag) {
            if (this.isSourceModeSuccess) {
                const textarea = this.$refs.htmlTextareaSuccess.$refs.textarea;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.inviteconfig.successHtml.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;

                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }

                this.inviteconfig.successHtml = this.inviteconfig.successHtml.substring(0, start) + replacement + this.inviteconfig.successHtml.substring(end);

                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                const visualEditor = this.$refs.visualEditorSuccess;
                if (!visualEditor) return;

                visualEditor.focus();

                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }

                this.inviteconfig.successHtml = visualEditor.innerHTML;
            }
        },
        toggleModeSuccess() {
            this.isSourceModeSuccess = !this.isSourceModeSuccess;
            if (!this.isSourceModeSuccess) {
                this.$nextTick(() => {
                    this.setVisualEditorContentSuccess(this.inviteconfig.successHtml);
                });
            }
        },
        handleVisualInputSuccess(event) {
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(() => {
                if (content !== this.inviteconfig.successHtml) {
                    this.inviteconfig.successHtml = content;
                }
            }, 300);
        },
        handleCompositionStartSuccess() {
            this.isComposing = true;
        },
        handleCompositionEndSuccess(event) {
            this.isComposing = false;
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            if (content !== this.inviteconfig.successHtml) {
                this.inviteconfig.successHtml = content;
            }
        },
        handlePasteSuccess() {
            // 让浏览器处理粘贴
        },
        handleKeydownSuccess() {
            // 让浏览器处理按键
        },
        setVisualEditorContentSuccess(content) {
            if (this.$refs.visualEditorSuccess && !this.isSourceModeSuccess) {
                this.$refs.visualEditorSuccess.innerHTML = content || '';
            }
        },

        // 第三个富文本编辑器的方法（邀请提示内容）
        insertHtmlPublic(tag, closeTag) {
            if (this.isSourceModePublic) {
                const textarea = this.$refs.htmlTextareaPublic.$refs.textarea;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.inviteconfig.publicHtml.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;

                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }

                this.inviteconfig.publicHtml = this.inviteconfig.publicHtml.substring(0, start) + replacement + this.inviteconfig.publicHtml.substring(end);

                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                const visualEditor = this.$refs.visualEditorPublic;
                if (!visualEditor) return;

                visualEditor.focus();

                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }

                this.inviteconfig.publicHtml = visualEditor.innerHTML;
            }
        },
        toggleModePublic() {
            this.isSourceModePublic = !this.isSourceModePublic;
            if (!this.isSourceModePublic) {
                this.$nextTick(() => {
                    this.setVisualEditorContentPublic(this.inviteconfig.publicHtml);
                });
            }
        },
        handleVisualInputPublic(event) {
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(() => {
                if (content !== this.inviteconfig.publicHtml) {
                    this.inviteconfig.publicHtml = content;
                }
            }, 300);
        },
        handleCompositionStartPublic() {
            this.isComposing = true;
        },
        handleCompositionEndPublic(event) {
            this.isComposing = false;
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            if (content !== this.inviteconfig.publicHtml) {
                this.inviteconfig.publicHtml = content;
            }
        },
        handlePastePublic() {
            // 让浏览器处理粘贴
        },
        handleKeydownPublic() {
            // 让浏览器处理按键
        },
        setVisualEditorContentPublic(content) {
            if (this.$refs.visualEditorPublic && !this.isSourceModePublic) {
                this.$refs.visualEditorPublic.innerHTML = content || '';
            }
        },

        // 显示添加按钮对话框
        showAddButtonDialog(rowIndex, btnListType = 'success') {
            // 根据类型选择对应的按钮列表
            const btnList = btnListType === 'public' ? this.inviteconfig.publicBtnList : this.inviteconfig.successBtnList;

            // 检查是否超过每行最大按钮数限制
            if (rowIndex !== -1 && btnList[rowIndex] && btnList[rowIndex].length >= 5) {
                this.$message.warning('每一行最多允许5个按钮');
                return;
            }

            // 重置编辑状态
            this.editingButtonRowIndex = -1;
            this.editingButtonIndex = -1;
            this.currentBtnListType = btnListType;

            this.currentRowIndex = rowIndex;
            this.buttonForm = {
                text: '',
                url: ''
            };
            this.buttonDialogVisible = true;
        },
        // 获取对话框标题
        getDialogTitle() {
            const btnList = this.currentBtnListType === 'public' ? this.inviteconfig.publicBtnList : this.inviteconfig.successBtnList;
            const listName = this.currentBtnListType === 'public' ? '公开提示' : '成功提示';

            if (this.editingButtonIndex !== -1) {
                // 编辑模式
                const rowNum = this.editingButtonRowIndex + 1;
                const btnNum = this.editingButtonIndex + 1;
                return `编辑${listName}第${rowNum}行第${btnNum}个按钮`;
            } else if (this.currentRowIndex === -1) {
                return `新增${listName}一行按钮`;
            } else {
                // 检查行是否存在，防止访问已删除的行
                if (btnList[this.currentRowIndex]) {
                    const rowNum = this.currentRowIndex + 1;
                    const btnNum = btnList[this.currentRowIndex].length + 1;
                    return `${listName}第${rowNum}行第${btnNum}个按钮`;
                } else {
                    return `新增${listName}一行按钮`;
                }
            }
        },
        // 确认添加按钮
        confirmAddButton() {
            // 验证表单
            this.$refs.buttonFormRef.validate((valid) => {
                if (!valid) {
                    return;
                }

                const buttonData = {
                    text: this.buttonForm.text.trim(),
                    url: this.buttonForm.url.trim()
                };

                // 根据类型选择对应的按钮列表
                const btnList = this.currentBtnListType === 'public' ? this.inviteconfig.publicBtnList : this.inviteconfig.successBtnList;

                if (this.editingButtonIndex !== -1) {
                    // 编辑模式：更新现有按钮
                    btnList[this.editingButtonRowIndex][this.editingButtonIndex] = buttonData;
                    this.$message.success('按钮编辑成功');

                    // 重置编辑状态
                    this.editingButtonRowIndex = -1;
                    this.editingButtonIndex = -1;
                } else if (this.currentRowIndex === -1) {
                    // 新增一行按钮
                    btnList.push([buttonData]);
                    this.$message.success('按钮添加成功');
                } else {
                    // 在指定行添加按钮 - 检查行是否存在
                    if (btnList[this.currentRowIndex]) {
                        btnList[this.currentRowIndex].push(buttonData);
                        this.$message.success('按钮添加成功');
                    } else {
                        // 如果指定行不存在，创建新行
                        btnList.push([buttonData]);
                        this.$message.success('按钮添加成功');
                    }
                }

                this.buttonDialogVisible = false;
            });
        },

        // 拖拽相关方法
        handleDragStart(rowIndex) {
            this.draggedRowIndex = rowIndex;
        },

        handleDragEnd() {
            this.draggedRowIndex = null;
        },

        handleDragOver(event) {
            event.preventDefault();
        },

        handleDrop(event, targetRowIndex, btnListType = 'success') {
            event.preventDefault();
            event.stopPropagation();

            if (this.draggedRowIndex === null || this.draggedRowIndex === targetRowIndex) {
                return;
            }

            const fromIndex = this.draggedRowIndex;
            const toIndex = targetRowIndex;

            // 根据类型选择对应的按钮列表
            const btnList = btnListType === 'public' ? this.inviteconfig.publicBtnList : this.inviteconfig.successBtnList;

            // 移动按钮行 - 创建新数组强制响应式更新
            const newButtons = [...btnList];
            const draggedRow = newButtons[fromIndex];

            // 移除原位置的行
            newButtons.splice(fromIndex, 1);
            // 插入到新位置
            newButtons.splice(toIndex, 0, draggedRow);

            // 替换整个数组触发响应式更新
            if (btnListType === 'public') {
                this.inviteconfig.publicBtnList = newButtons;
            } else {
                this.inviteconfig.successBtnList = newButtons;
            }

            // 强制Vue重新渲染
            this.$nextTick(() => {
                this.$forceUpdate();
            });

            this.$message.success(`第${fromIndex + 1}行已移动到第${toIndex + 1}行`);
        },

        // 解析按钮文本数据为二维数组
        parseButtonData(buttonText) {
            if (!buttonText || typeof buttonText !== 'string') {
                return [];
            }

            try {
                // 1. 按换行符分割成行
                const lines = buttonText.split('\n').filter(line => line.trim());

                // 2. 每行按分号分割成按钮
                const buttons = lines.map(line => {
                    return line.split(';').filter(item => item.trim()).map(item => {
                        // 3. 解析每个按钮的文字和链接 格式: 文字(链接)
                        const match = item.trim().match(/^(.+?)\((.+?)\)$/);
                        if (match) {
                            return {
                                text: match[1].trim(),
                                url: match[2].trim()
                            };
                        }
                        return null;
                    }).filter(Boolean);
                }).filter(row => row.length > 0);

                return buttons;
            } catch (error) {
                console.error('解析按钮数据失败:', error);
                return [];
            }
        },
        async handleSetInvalid(row) {
            // 这里应该添加设置无效邀请的逻辑
            try {
                const response = await api.updateInviteUsers(row.id, {
                    isInvalid: row.isInvalid === 0 ? 1 : 0,
                    invalidType: row.isInvalid === 0 ? 'manual' : 'none'
                })
                if (response.data.code === 0) {
                    this.$message.success('状态更新成功')
                    ////刷新当前页数据
                    this.fetchInviteUsers();
                } else {
                    this.$message.error(response.data.message || '状态更新失败')
                    // 恢复原状态
                    row.status = row.status === 1 ? 0 : 1
                }
            } catch (error) {
                console.error('状态更新失败:', error)
                this.$message.error('状态更新失败')
                // 恢复原状态
                row.status = row.status === 1 ? 0 : 1
            }
        },
        handleInviteUsersSizeChange(val) {
            this.inviteUsersPageSize = val;
            this.inviteUsersCurrentPage = 1;
            this.fetchInviteUsers();
        },
        handleInviteUsersCurrentChange(val) {
            this.inviteUsersCurrentPage = val;
            this.fetchInviteUsers();
        },
        async fetchInviteUsers() {
            this.inviteUsersLoading = true;
            try {
                const params = {
                    page: this.inviteUsersCurrentPage,
                    pageSize: this.inviteUsersPageSize,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentInviteGroupId || this.currentUserInfo.groupId,
                    userId: this.currentInviteUserId
                };
                const response = await api.getInviteUsersList(params);
                if (response.data.code === 0) {
                    this.inviteUsersData = response.data.data.records;
                    this.inviteUsersTotal = response.data.data.total;
                } else {
                    this.$message.error(response.data.message || '获取邀请用户列表失败');
                }
            } catch (error) {
                console.error('获取邀请用户列表失败:', error);
                this.$message.error('获取数据失败');
            } finally {
                this.inviteUsersLoading = false;
            }
        },

        // 初始化富文本编辑器
        initRichTextEditor() {
            this.$nextTick(() => {
                // 初始化第一个富文本编辑器（我的链接回复内容）
                if (this.$refs.visualEditorMyLink && !this.isSourceModeMyLink) {
                    this.$refs.visualEditorMyLink.innerHTML = this.inviteconfig.myLinkHtml || '';
                }

                // 初始化第二个富文本编辑器（邀请成功提示内容）
                if (this.$refs.visualEditorSuccess && !this.isSourceModeSuccess) {
                    this.$refs.visualEditorSuccess.innerHTML = this.inviteconfig.successHtml || '';
                }

                // 初始化第三个富文本编辑器（邀请提示内容）
                if (this.$refs.visualEditorPublic && !this.isSourceModePublic) {
                    this.$refs.visualEditorPublic.innerHTML = this.inviteconfig.publicHtml || '';
                }
            });
        },
        removeButtonRow(rowIndex, btnListType = 'success') {
            const btnList = btnListType === 'public' ? this.inviteconfig.publicBtnList : this.inviteconfig.successBtnList;
            btnList.splice(rowIndex, 1);
        },
    },
    mounted() {
        if (this.$store.state.user) {
            this.loadUserInfo(this.$store.state.user);
            this.fetchData()
            this.fetchSetting()
        }
        this.initRichTextEditor();
    }
}
</script>

<style scoped>
.auto-reply {
    padding: 20px;
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.stats-section {
    margin-bottom: 20px;
}

.stats-card {
    text-align: center;
}

.stats-item {
    padding: 10px;
}

.stats-value {
    font-size: 24px;
    font-weight: bold;
    color: #409eff;
    margin-bottom: 5px;
}

.stats-label {
    font-size: 14px;
    color: #666;
}

.keyword-display {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.keyword-desc {
    margin-top: 5px;
}

.reply-content {
    max-width: 300px;
    word-break: break-all;
}

.media-url {
    margin-top: 5px;
    padding: 5px;
    background: #f5f5f5;
    border-radius: 4px;
}

.advanced-settings {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}

.upload-demo {
    text-align: center;
}

.el-upload__tip {
    color: #666;
    font-size: 12px;
    margin-top: 10px;
}

.placeholder-description {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
}

.button-input-area {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    min-height: 60px;
    margin-bottom: 10px;
}

.button-row {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.button-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.button-controls {
    display: flex;
    gap: 10px;
}

.delete-row-btn {
    background-color: #fee;
    color: #f56c6c;
    border-color: #fde2e2;
}

.delete-row-btn:hover {
    background-color: #fdd;
    color: #f23c3c;
}

.other-settings {
    margin-top: 15px;
}

.setting-label {
    color: var(--el-text-color-regular);
    margin-right: 12px;
}

.form-label-with-icon {
    display: flex;
    align-items: center;
    gap: 4px;
}

.required-asterisk {
    color: var(--el-color-danger);
    margin-right: 4px;
}

.condition-input-group {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.reply-content-head {
    display: flex;
    align-items: flex-start;
}

.keyword-tags-input {
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    border: 1px solid var(--el-border-color);
    border-radius: 4px;
    padding: 2px 8px;
    min-height: 32px;
    max-width: 350px;
}

.keyword-new-tag-input {
    border: none;
    outline: none;
    flex-grow: 1;
    min-width: 80px;
    background-color: transparent;
}

.html-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: white;
    max-width: 460px;
}

.html-textarea {
    width: 100%;
    max-width: 460px;
}

.html-textarea :deep(.el-textarea__inner) {
    max-height: 200px;
    min-height: 120px;
    resize: vertical;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.html-toolbar {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-bottom: 1px solid #dcdfe6;
    background: #f5f7fa;
    flex-wrap: wrap;
    gap: 4px;
}

.html-toolbar button {
    padding: 4px 8px;
    border: 1px solid #dcdfe6;
    background: white;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s;
    min-width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.html-toolbar button:hover:not(:disabled) {
    background: #ecf5ff;
    border-color: #409eff;
}

.html-toolbar button.is-active {
    background: #409eff;
    color: white;
    border-color: #409eff;
}

.html-toolbar button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f5f7fa;
}

.html-toolbar .divider {
    margin: 0 8px;
    color: #dcdfe6;
}

.editor-content-area {
    border: 1px solid #dcdfe6;
    border-top: none;
    border-radius: 0 0 4px 4px;
}

.visual-editor {
    min-height: 50px;
    max-height: 200px;
    height: 200px;
    padding: 12px;
    outline: none;
    cursor: text;
    line-height: 1.6;
    font-size: 14px;
    background: white;
    border-radius: 0 0 4px 4px;
    direction: ltr;
    text-align: left;
    unicode-bidi: normal;
    overflow-y: auto;
    word-wrap: break-word;
    overflow-wrap: break-word;
    box-sizing: border-box;
}

.visual-editor:focus {
    outline: none;
}

.visual-editor p {
    margin: 8px 0;
}

.visual-editor p:first-child {
    margin-top: 0;
}

.visual-editor p:last-child {
    margin-bottom: 0;
}

.visual-editor h1,
.visual-editor h2,
.visual-editor h3 {
    margin: 16px 0 8px 0;
    font-weight: bold;
}

.visual-editor h1 {
    font-size: 1.5em;
}

.visual-editor h2 {
    font-size: 1.3em;
}

.visual-editor ul,
.visual-editor ol {
    padding-left: 20px;
    margin: 8px 0;
}

.visual-editor li {
    margin: 4px 0;
}

.visual-editor strong,
.visual-editor b {
    font-weight: bold;
}

.visual-editor em,
.visual-editor i {
    font-style: italic;
}

.visual-editor u {
    text-decoration: underline;
}

.visual-editor[contenteditable]:empty:before {
    content: "请输入回复内容...";
    color: #c0c4cc;
    font-style: italic;
}

.reply-type-horizontal {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
}

.type-select-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    min-width: 250px;
}

.media-url-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 350px;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #409eff;
    animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.reply-type-dropdown {
    max-height: 200px;
    overflow-y: auto;
    z-index: 9999;
}

/* 按钮行列表样式 */
.button-rows-list {
    margin-bottom: 2px;
}

.button-row-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 2px;
    margin-left: 35px;
    /* 与新增一行按钮对齐 */
    border-radius: 6px;
    padding: 6px;
    transition: all 0.3s ease;
}

.button-row-wrapper.drag-over {
    background-color: #f0f9ff;
    border: 2px dashed #1890ff;
    transform: scale(1.02);
}

.gray-buttons-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    /* 不允许换行 */
    width: 480px;
    /* 与新增一行按钮宽度一致 */
    flex-shrink: 0;
    /* 不允许收缩 */
}

.button-item {
    background: #a8a8a8;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    border: none;
    cursor: default;
    white-space: nowrap;
    /* 文字不换行 */
    flex: 1;
    /* 弹性宽度，平均分配空间 */
    min-width: 0;
    /* 允许收缩到内容宽度 */
    overflow: hidden;
    /* 防止内容溢出 */
    text-overflow: ellipsis;
    /* 文字过长时显示省略号 */
    position: relative;
    /* 为操作按钮定位提供参考 */
    transition: all 0.3s ease;
    height: 36px;
    /* 确保与蓝色按钮高度一致 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.button-item:hover {
    background: #909399;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.button-actions {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 2;
}

.button-item:hover .button-actions {
    opacity: 1;
}

.button-action-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.edit-icon {
    background: #409eff;
}

.edit-icon:hover {
    background: #66b1ff;
    transform: scale(1.1);
}

.delete-icon {
    background: #f56c6c;
}

.delete-icon:hover {
    background: #f78989;
    transform: scale(1.1);
}

.button-action-icon .el-icon {
    font-size: 12px;
    color: white;
}

.add-button-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.add-to-row-button {
    background: #1890ff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.3s ease;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.add-to-row-button:hover {
    background: #40a9ff;
}

/* 新增按钮样式 */
.button-controls {
    display: flex;
    align-items: center;
    padding: 0;
}

.add-row-button {
    border: 1px dashed #d9d9d9;
    background: #fff;
    color: #666;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
    outline: none;
    min-width: 480px;
    height: 36px;
    margin-left: 35px;
}

.add-row-button:hover {
    border-color: #1890ff;
    color: #1890ff;
}

.drag-icon-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: grab;
    user-select: none;
}

.drag-icon-container:active {
    cursor: grabbing;
}

.drag-icon {
    font-size: 16px;
    color: #8c8c8c;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s ease;
}

.drag-icon-container:hover .drag-icon {
    color: #1890ff;
}

.drag-icon-container[draggable="true"] {
    cursor: grab;
}

.drag-icon-container[draggable="true"]:active {
    cursor: grabbing;
}

/* 变量说明样式 */
.variable-help-text {
    margin-top: -10px;
    margin-bottom: 20px;
    margin-left: 120px;
    max-width: 430px;
    /* 与表单标签对齐 */
    padding: 12px 16px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.6;
    color: #6c757d;
}

.variable-item {
    display: inline;
}

.variable-help-text code {
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #bbdefb;
}

.carousel-tabs .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 40px 12px 40px;
}

.carousel-banner {
    background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%);
    color: #fff;
    border-radius: 18px 18px 0 0;
    padding: 36px 36px 18px 36px;
    text-align: left;
    margin-bottom: -18px;
    box-shadow: 0 4px 24px rgba(100, 100, 100, 0.10);
}

.carousel-banner-title {
    font-size: 2.2rem;
    font-weight: bold;
    letter-spacing: 2px;
}

.carousel-banner-desc {
    font-size: 1.1rem;
    opacity: 0.90;
    margin-top: 10px;
}

.carousel-setting-card {
    border-radius: 18px;
    box-shadow: 0 2px 18px rgba(100, 100, 100, 0.10);
    padding: 38px 28px 28px 28px;
    margin-top: 0;
}

.form-section-title {
    font-size: 1.15rem;
    font-weight: 600;
    margin: 28px 0 10px 0;
    color: #6a82fb;
    letter-spacing: 1px;
}

.big-switch :deep(.el-switch__core) {
    width: 56px !important;
    height: 28px !important;
    border-radius: 18px !important;
}

.big-switch :deep(.el-switch__action) {
    width: 28px !important;
    height: 28px !important;
}

.big-submit-btn {
    width: 280px;
    background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%);
    border: none;
    border-radius: 10px;
    font-size: 1.15rem;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(252, 92, 125, 0.12);
    padding: 14px 0;
    margin-top: 18px;
}

/* 拖拽上传样式 */
.json-upload-drag {
    width: 100%;
}

.json-upload-drag :deep(.el-upload-dragger) {
    width: 100%;
    height: 120px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.json-upload-drag :deep(.el-upload-dragger:hover) {
    border-color: #409eff;
    background: #f0f9ff;
}

.json-upload-drag :deep(.el-upload-dragger.is-dragover) {
    border-color: #409eff;
    background: #e6f7ff;
    transform: scale(1.02);
}

.json-upload-drag :deep(.el-icon--upload) {
    font-size: 28px;
    color: #c0c4cc;
    margin-bottom: 8px;
    transition: color 0.3s ease;
}

.json-upload-drag :deep(.el-upload-dragger:hover .el-icon--upload) {
    color: #409eff;
}

.json-upload-drag :deep(.el-upload__text) {
    color: #606266;
    font-size: 14px;
    text-align: center;
    line-height: 1.5;
}

.json-upload-drag :deep(.el-upload__text em) {
    color: #409eff;
    font-style: normal;
    font-weight: bold;
}

.json-upload-drag :deep(.el-upload__tip) {
    color: #888;
    font-size: 12px;
    line-height: 1.6;
    margin-top: 8px;
    text-align: center;
}

.media-group-manager {
    display: flex;
    flex-direction: column;
    gap: 15px;
    min-height: 200px;
}

.media-item {
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.media-item-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.media-index {
    font-weight: bold;
    color: #409eff;
    min-width: 30px;
}

.add-media-section {
    display: flex;
    justify-content: center;
    padding: 20px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
}

.add-media-section:hover {
    border-color: #409eff;
    background: #f0f9ff;
}

.media-management-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
}
</style>